import React from 'react';
import {useParams} from 'react-router';
// @ts-ignore
import {BasicButton, NegativeButton} from 'shared/layout';
import {Button} from 'semantic-ui-react';
import styled from 'styled-components';
import {
  useCurrentUserQuery,
  useFollowMutation,
  useUnfollowMutation,
  GroupType,
  UserType,
  useEventQuery,
} from 'api';

const isFollow = (group: GroupType, currentUser: UserType) =>
  group.followers &&
  group.followers.map((follow) => follow.userId).includes(currentUser.id);

export default () => {
  const {eventId} = useParams();
  const {data: {currentUser = null} = {}} = useCurrentUserQuery();

  const {data: {event = null} = {}} = useEventQuery({
    variables: {id: eventId},
    fetchPolicy: 'cache-and-network',
  });

  const [follow, {loading: loadingFollow}] = useFollowMutation();
  const [unfollow, {loading: loadingUnFollow}] = useUnfollowMutation();

  if (!event || !event.group) return null;

  return (
    <div>
      <Title>主催グループ</Title>
      <Container>
        <a href={`/groups/${event.group.id}`}>
          <Image src={event.group.mainImageUrl} />
        </a>
        <Body>
          <Group>
            <a href={`/groups/${event.group.id}`}>{event.group.name}</a>
          </Group>
          <FollowBlock>
            <Follow>
              <span>フォロワー</span>
              <Count>{event.group.followers.length}</Count>人
            </Follow>

            {currentUser ? (
              isFollow(event.group, currentUser) ? (
                <NegativeButton
                  onClick={() =>
                    unfollow({variables: {groupId: event.group.id}})
                  }
                  loading={loadingUnFollow}>
                  フォロー中
                </NegativeButton>
              ) : (
                <BasicButton
                  onClick={() => follow({variables: {groupId: event.group.id}})}
                  loading={loadingFollow}>
                  フォローする
                </BasicButton>
              )
            ) : (
              <LoginLink
                as="a"
                href={`/signin?return_url=${window.location.href}`}>
                フォローする
              </LoginLink>
            )}
          </FollowBlock>
        </Body>
      </Container>
    </div>
  );
};

const Title = styled.div`
  margin-top: 20px;
  margin-bottom: 15px;
  color: #212121;
`;

const Container = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
`;
const Image = styled.img`
  width: 100%;
  height: 140px
  object-fit: cover;
`;

const Body = styled.div`
  height: 130px;
  padding: 15px 20px;
`;

const Group = styled.div`
  color: #424242;
  font-size: 15px;
  font-weight: bold;

  a {
    color: #424242;
  }
`;

const FollowBlock = styled.div`
  display: flex;
  margin-top: 20px;

  &&& {
    button {
      margin-left: auto;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

const Follow = styled.div`
  line-height: 38px;
  color: #ef5350;

  span {
    font-size: 11px;
    color: #424242;
    margin-right: 5px;
  }
`;

const Count = styled.div`
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
`;

const LoginLink = styled(Button)`
  &&& {
    margin-left: 20px;
    border-radius: 20px;
    border: solid 1px #ef5350;
    color: #ef5350 !important;
    border: solid 1px #ef5350;
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-radius: 28px;
    font-size: 13px;

    &:hover {
      color: #ef5350 !important;
      background-color: #f9f0f0 !important;
    }
  }
`;
